import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import StyleTransferPreviewContainer from '../StyleTransferPreview/StyleTransferPreview.container';
import { SceneBuilder } from './SceneBuilder';

export type SceneBuilderContainerProps = {};

export function SceneBuilderContainer(_props: SceneBuilderContainerProps) {
  const dispatch = useDispatch();
  const sceneItems = useSelector(selectors.base.$sceneItems);
  const realtimeState = useSelector(selectors.raw.$rawRealtimeState);
  const characters = useSelector(selectors.base.$characters);
  const editMode = useSelector(selectors.base.$editMode);
  const { sceneBackgroundOn } = realtimeState;

  const callbacks = useMemo(
    () => ({
      setTileArea: (value?: Area) => {
        dispatch(actions.realtimeState.patch({ tileArea: value }));
      },
    }),
    []
  );

  if (editMode !== 'scene' && editMode !== 'live') {
    return null;
  }

  return (
    <SceneBuilder
      sceneBackgroundOn={sceneBackgroundOn}
      characters={characters}
      sceneItems={sceneItems}
      editMode={editMode}
      callbacks={callbacks}
    >
      <StyleTransferPreviewContainer />
    </SceneBuilder>
  );
}

export default SceneBuilderContainer;
